// Broad discovery filters; original game tags remain available to search.
export const CATALOG_CATEGORIES = [
  { name: '休闲益智', tags: ['休闲', '益智', '消除', '数独', '解谜', '街机'] },
  { name: '动作冒险', tags: ['动作', '冒险', '跑酷', '射击', '玄幻', '角色扮演'] },
  { name: '棋牌', tags: ['棋牌', '斗地主', '麻将', '扑克', '棋类'] },
  { name: '策略经营', tags: ['策略', '经营', '塔防', '回合制', '模拟'] },
  { name: '体育竞技', tags: ['体育', '竞技', '桌球', '台球', '赛车'] },
];

export function matchesCategory(game: { free: boolean; categories: string[] }, category: string) {
  if (category === '全部') return true;
  if (category === '免费') return game.free;
  const group = CATALOG_CATEGORIES.find((item) => item.name === category);
  return !!group && game.categories.some((tag) => tag === group.name || group.tags.includes(tag));
}
